import React, { useMemo } from 'react';
import { useIntl } from 'react-intl';
import { Link } from 'react-router-dom';

import { Button, FieldRow, FormFooter, Notification } from '@xsolla/ui-core';
import { AlertExclamation, AlertExclamationColorful } from '@xsolla/ui-icons';
import { ModalAlert } from '@xsolla/ui-modal';

import { ConnectedLaunchers, ConnectedLaunchersNew } from '../../../api/dasboard/types';
import { usePaths } from '../../../routes/routesHelper';
import { getRandomString } from '../../../utils';
import {
  LauncherLinksWrapper,
  LaunchersDescription,
  LaunchersTitle,
  LauncherWrapper,
  StyledCog,
  StyledLink
} from './styleConnectedLaunchers';

interface Props {
  projectName: string;
  connectedLaunchers: ConnectedLaunchers;
  connectedLaunchersNew: ConnectedLaunchersNew;
  onClose: () => void;
}

const ConnectedLaunchersForm = ({
  connectedLaunchers,
  connectedLaunchersNew,
  projectName,
  onClose
}: Props): JSX.Element => {
  const { launcherProjectPath, launcherProjectPathNew } = usePaths();
  const intl = useIntl();

  const modalFooter = useMemo(() => {
    return (
      <FormFooter>
        <FieldRow justify="center" stretched>
          <Button look="tertiary" palette="muted" onClick={onClose}>
            {intl.formatMessage({ id: 'button.close' })}
          </Button>
        </FieldRow>
      </FormFooter>
    );
  }, [onClose]);

  return (
    <ModalAlert footer={modalFooter}>
      <LauncherWrapper>
        <AlertExclamationColorful size={40} />
        <LaunchersTitle center indent="sm">
          {intl.formatMessage({ id: 'delete-project-launchers.title' }, { projectName })}
        </LaunchersTitle>
        <LaunchersDescription>
          {intl.formatMessage({ id: 'delete-project-launchers.description' }, { projectName })}
        </LaunchersDescription>
        <Notification icon={AlertExclamation} palette="brand">
          {intl.formatMessage({ id: 'delete-project-launchers.notification' })}
        </Notification>

        <LauncherLinksWrapper>
          {connectedLaunchers.map((launcher) => (
            <StyledLink key={getRandomString()}>
              <Link to={launcherProjectPath(launcher.external_id)}>
                {intl.formatMessage(
                  { id: 'delete-project-launchers.link' },
                  { launcherName: launcher.name }
                )}
                <StyledCog />
              </Link>
            </StyledLink>
          ))}
          {connectedLaunchersNew.map((launcher) => (
            <StyledLink key={getRandomString()}>
              <Link to={launcherProjectPathNew(launcher.id)}>
                {intl.formatMessage(
                  { id: 'delete-project-launchers.link' },
                  { launcherName: launcher.id }
                )}
                <StyledCog />
              </Link>
            </StyledLink>
          ))}
        </LauncherLinksWrapper>
      </LauncherWrapper>
    </ModalAlert>
  );
};

export default ConnectedLaunchersForm;
